import { useTheme } from "@mui/material";
import { getReferenceStyles } from "common/consts/referenceStyles";

export const useReferenceStyles = () => {
  const theme = useTheme();

  return getReferenceStyles(theme);
};
